import React from 'react';
import { Link } from 'react-router-dom';
import { PageTitle } from '../../../components';
import { FaCalendarAlt, FaUsers, FaClock } from 'react-icons/fa';
import { legends, titles } from '../../../constants';
import './LegendPage.css';
import { useTranslation } from 'react-i18next';

const LegendPage = () => {

    const { t } = useTranslation();

    const featuredLegend = legends.find(item => item.id === 1);
    const otherLegends = legends.filter(item => item.id !== 1);

    return (
        <>
            <PageTitle title={t(titles.legends)} page={t(titles.legends)} />

            {featuredLegend && (
                <section className='legend-single featured-section'>
                    <div className='container'>
                        <div className='legend-intro'>

                            <div className='image'>
                                <img src={featuredLegend.image} alt={t(featuredLegend.title)} />
                            </div>

                            <div className='information'>
                                <h3>{t(featuredLegend.title)}</h3>
                                <h5>{t(featuredLegend.subtitle)}</h5>

                                <div className='legend-about'>
                                    <div className='text' style={{ whiteSpace: 'pre-line' }}>
                                        {t(featuredLegend.content)}
                                    </div>
                                </div>

                                <ul className="legend-meta-info">
                                    <li><h6><FaCalendarAlt className='icon' /> {t(titles.data)}:</h6><span>{t(featuredLegend.date)}</span></li>
                                    <li><h6><FaUsers className='icon' /> {t(titles.authors)}:</h6><span>{t(featuredLegend.author)}</span></li>
                                    <li><h6><FaClock className='icon' /> {t(titles.czytaj)}:</h6><span>{t(featuredLegend.readTime)}</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
            )}

            <section className="legends-list-section" style={{ padding: '50px 0', background: '#f9f9f9' }}>
                <div className="container">

                    <div className="legends-grid">
                        {otherLegends.map((item) => (
                            <div key={item.id} className="legend-card">

                                <div className="card-content">
                                    <h4>{t(item.title)}</h4>
                                    <p>{t(item.subtitle)}</p>

                                    <Link to={`/Legenda/${item.id}`} className="btn-read-more">
                                        {t(titles.czytajDalej)}
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default LegendPage;